import { StyleSheet } from 'aphrodite';
import { destructive, gray4, header } from '../../../../../../web/styles/colors';

export const s = StyleSheet.create({
	dialogBody: {
		minHeight: '400px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	messageList: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		flex: 1,
		overflowY: 'auto',
		maxHeight: '400px',
	},
	emptyState: {
		padding: '32px',
		textAlign: 'center',
		color: header,
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	formField: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	label: {
		fontWeight: 500,
		fontSize: '14px',
	},
	required: {
		color: destructive,
	},
	helperText: {
		fontSize: '12px',
		color: gray4,
	},
	errorText: {
		fontSize: '12px',
		color: destructive,
	},
	addButton: {
		alignSelf: 'flex-start',
	},
});
